<template>
	<div class="contact_edit" v-if="showStatafter">
		<div class="contact_card_btn">
			<a href="javascript:;" @click="emptyCont(item)">清空信息</a>
		</div>
		<div class="password_item clearfix">
			<label class="password_item_l"><i>*</i>姓名：</label>
			<div class="info_item showpassword_r mb20">
				<input type="text" placeholder="请输入您的姓名" v-model="item.name">
			</div>
		</div>
		<div class="password_item clearfix">
			<label class="password_item_l"><i>*</i>电话：</label>
			<div class="info_item showpassword_r mb20">
				<input type="text" placeholder="请输入您的联系电话，用于接收重要通知" v-model="item.phone">
			</div>
		</div>
		<div class="password_item clearfix">
			<label class="password_item_l"><i>*</i>邮箱：</label>
			<div class="info_item showpassword_r mb20">
				<input type="text" placeholder="请输入您的企业邮箱，用户接收通知" v-model="item.email">
			</div>
		</div>
		<div class="hr"></div>
		<div class="password_item clearfix">
			<div class="addTab">
				<a href="javascript:;" class="bluebd_btn" @click="cancleFun(item)">取消</a>
				<a href="javascript:;" class="blue_btn marginLeft10" @click="holdData(item)">确认</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'showArea',
		data() {
			return {
				userdevId: sessionStorage.getItem('devId'),
			}
		},
		props: ['item', 'showStatafter', 'isAdd'], // showStatafter 对于编辑弹窗的状态    ||  isAdd 是在保存联系人时判断 是调新增的接口还是调编辑的接口的保存     
		methods: {
			//编辑联系人的时候清空里面的信息
			emptyCont(item) {
				item.name = '';
				item.phone = '';
				item.email = '';

			},
			//保存联系人信息
			holdData(item) {
				//编辑联系人，定义传入的参数
				let reviseParams = {
					devId: this.userdevId, //开发者ID
					contactId: item.contactId, // 联系人ID
					name: item.name, //姓名
					phone: item.phone, //电话
					email: item.email //邮箱
				}
				var numLength = 0;
				var addUser = 0;
				var url = '/ystOpenPlatformBff/editContact';
				var message = '联系人保存成功！'
				if(this.isAdd) {
					url = '/ystOpenPlatformBff/insertContact'
					message = '联系人新增成功！'
				}
				if(this.check.calibration(reviseParams)) {
					this.http.post(url, reviseParams, res => {
						console.log(res);
						if(res.success) {
							this.$Message.success(message);
							let params = {
								"devId": this.userdevId
							}; //查询的时候必须要传开发者ID
							this.http.post('/ystOpenPlatformBff/userContact', params, res => {
								if(res.success) {
									if(res.data.length == 1) { //最多还能添加几个联系人的校验信息			
										numLength = 2;
										addUser = true;
									} else if(res.data.length == 2) {
										numLength = 1;
										addUser = true;
									} else if(res.data.length == 3) {
										numLength = 0;
										addUser = false;
									}
									for(var i = 0, len = res.data.length; i < len; i++) {
										res.data[i].isbeforeShow = true;
										res.data[i].isShow = false;
									}
									item.isShow = !item.isShow;
									item.isbeforeShow = !item.isbeforeShow;
									for(var i = 0, len = res.data.length; i < len; i++) {
										res.data[i].isbeforeShow = true;
										res.data[i].isShow = false;
										res.data[i].model1 = false;
									}
									if(this.isAdd) {
										this.$emit('getInit', res.data, numLength, addUser, false, true);
									} else {
										this.$emit('getSave', true);
									}

									this.delectStatue == false;

								} else {
									this.$Message.error(res.message);
								}
							})
						} else {
							this.$Message.error(res.message);
						}
					})
				}

			},
			//取消
			cancleFun(item) {
				item.isShow = !item.isShow;
				item.isbeforeShow = !item.isbeforeShow;
				item = this.cache;
				if(this.isAdd) {
					this.$emit('getInit', false, 100, 100, false, true);
				} else {
					this.$emit('getSave', true);
				}
				this.$emit('init');
				this.delectStatue == false;
			}
		}
	}
</script>
<style lang="scss">
	.showpassword_r {
		float: left;
		width: 50%;
	}
	
	.hr {
		border-bottom: 1px solid $borderC;
		width: 560px;
		margin: 0 auto 30px;
	}
	
	.addTab {
		text-align: center;
	}
	
	.marginLeft10 {
		margin-left: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/public/ShowArea.vue